<template>
  <accordion ref="accordion" v-model="mostrarAccordion">
    <div slot="header">2. Qualificação</div>
    <div v-if="!loading">
      <unicom-linha
        style="padding: 16px; padding-left: 24px"
        :espacamento="false"
        v-for="(info, index) in objetoInformacoesComputed"
        :key="index"
        :class="{ par: index % 2 === 0 }"
      >
        <unicom-coluna sm="12" md="6">
          <div class="medio">
            {{ nomeCampos[info[0]] }}
          </div>
        </unicom-coluna>
        <unicom-coluna sm="12" md="6">
          <div class="medio">{{ info[1] }}</div>
        </unicom-coluna>
      </unicom-linha>
    </div>
    <unicom-spinner
      v-else
      style="min-height: 76px"
      :tamanhoLoading="62"
      :tamanhoLinha="7"
      :velocidade="0.5"
      :marginTopTexto="30"
      mensagem="Carregando..."
    />
  </accordion>
</template>

<script>
import DadosGeraisMixin from "../DadosGeraisMixin";

export default {
  name: "Qualificacao",
  mixins: [DadosGeraisMixin],
  data() {
    return {
      objetoInformacoes: {
        redeAcidenteDeTrabalho: "",
        novisa: "",
        qualiss: "",
        posGraduacao: "",
        doutoradoOuPosDoutorado: "",
        certificacaoIso9001: "",
        tituloDeEspecialista: "",
        residenciaEmSaude: ""
      },
      nomeCampos: {
        redeAcidenteDeTrabalho: "Rede Acidente de Trabalho?",
        novisa: "Participação NOTIVISA?",
        qualiss: "Participação QUALISS?",
        posGraduacao: "Possui pós-graduação?",
        doutoradoOuPosDoutorado: "Possui doutorado ou pós-doutorado?",
        certificacaoIso9001: "Possui certificação ISO9001?",
        tituloDeEspecialista: "Indicador de Título de Especialista?",
        residenciaEmSaude:
          "Indicador de residência em saúde reconhecida pelo MEC?"
      }
    };
  },
  methods: {
    init() {
      if (this.iniciado) return;

      this.loading = true;
      this.sleep(150).then(() => {
        this.getQualificacao(this.idRnpPrestador)
          .then(res => {
            let objetoQualificacao = res.data;

            if (!this.mostrarTotasQualificacoes) {
              delete this.nomeCampos.posGraduacao;
              delete this.objetoInformacoes.posGraduacao;
              delete this.nomeCampos.doutoradoOuPosDoutorado;
              delete this.objetoInformacoes.doutoradoOuPosDoutorado;
              delete this.nomeCampos.tituloDeEspecialista;
              delete this.objetoInformacoes.tituloDeEspecialista;
              delete this.nomeCampos.residenciaEmSaude;
              delete this.objetoInformacoes.residenciaEmSaude;
              this.montarQualificacao(objetoQualificacao, false);
            } else {
              this.montarQualificacao(objetoQualificacao, true);
            }

            this.iniciado = true;
          })
          .catch(() => {
            this.mostrarAccordion = false;
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },
    montarQualificacao(objetoQualificacao, todos = false) {
      Object.entries(objetoQualificacao).forEach(e => {
        if (!todos && e[0] === "posGraduacao") return;
        if (!todos && e[0] === "doutoradoOuPosDoutorado") return;
        if (!todos && e[0] === "tituloDeEspecialista") return;
        if (!todos && e[0] === "residenciaEmSaude") return;
        this.objetoInformacoes[e[0]] = e[1] ? e[1].descricao : "Não Possui";
      });
    }
  },
  computed: {
    objetoInformacoesComputed() {
      return Object.entries(this.objetoInformacoes);
    },
    mostrarTotasQualificacoes() {
      return this.$store.getters.getMostrarCamposQualificacao;
    }
  }
};
</script>

<style lang="scss" scoped>
.par {
  background: #f2f5f4;
}
</style>
